import logo from '../assets/logo-white.svg';
import logoOnlyWhite from '../assets/Images/FSLogoOnlyWhite.png';
import logoBlue from '../assets/Images/FSLogoColor.png';
import downArrow from '../assets/down_arrow.svg';
import upArrow from '../assets/up_arrow.svg';
import facebook from '../assets/facebook.png';
import linkedIn from '../assets/linkedin.png';
import twitter from '../assets/twitter.png';
import gaugePointer from '../assets/gauge.png';
import gaugeModal from '../assets/gauge-modal.png';
import defaultAvatar from '../assets/placeholder-avatar.png';
import tanks from '../assets/challenges/tanks.png';
import space from '../assets/challenges/space.png';
import bluff from '../assets/challenges/bluff.jpg';
import art from '../assets/challenges/art.jpg';
import elevator from '../assets/challenges/elevator.png';
import deFlag from '../assets/flags/de.svg';
import enFlag from '../assets/flags/en.svg';
import svFlag from '../assets/flags/sv.svg';
import defaultCompanyLogo from '../assets/Images/placeholder-company.png';
import paymentBackground from '../assets/Images/payment-background.jpeg';

export const Images = {
  logo,
  logoOnlyWhite,
  logoBlue,
  downArrow,
  upArrow,
  facebook,
  linkedIn,
  twitter,
  gaugePointer,
  gaugeModal,
  defaultAvatar,
  tanks,
  space,
  bluff,
  art,
  elevator,
  deFlag,
  enFlag,
  svFlag,
  defaultCompanyLogo,
  paymentBackground,
};
